import { useNavigate } from "react-router-dom";
import CustomPage from "components/CustomPage";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { Stack, Typography } from "@mui/material";
import { CalendarMonth, DeviceThermostat, HomeRepairService, SettingsPower, Speed, ThermostatAutoOutlined, WaterDropOutlined } from "@mui/icons-material";
import NullCheck from "components/NullCheck";
import { PLUGIN_NAME } from "config/const";
import useCheckData from "hooks/CheckData";
import { useSelector } from "react-redux";
import { sub } from "date-fns";
import { temperatureReportControllers } from 'containers/microControllers/b22/temperatureReports';

const Reports = () => {
  const { bt } = useBizTypeTranslation();
  const navigate = useNavigate();
  const { hasPlugin } = useCheckData()
  const mcsInfo = useSelector((state) => state?.mc.info);
  const mcList = useSelector((state) => state.mc.mcList);
  const user = useSelector((state) => state.userSettings?.user);

  const REPORTS_BUTTONS = [
    {
      id: 1,
      pluginName: PLUGIN_NAME.SERVICES_CALL,
      show: true,
      title: "SERVICES_CALL",
      navigate: "Services-Call",
      icon: <HomeRepairService sx={{ fontSize: 90 }} color="primary" />,
    },
    {
      id: 2,
      pluginName: PLUGIN_NAME.METER_READ,
      show: true,
      title: "METER_READ_REPORT",
      navigate: "Meter-Read",
      icon: <Speed sx={{ fontSize: 90 }} color="primary" />,
    },
    {
      id: 3,
      pluginName: PLUGIN_NAME.MICRO_CONTROLLERS,
      show: mcsInfo?.hasTempReports,
      title: "TEMP_AVG_REPORT",
      subTitle: "HOURLY_AVERAGE",
      navigate: "Mc-Avg-Temp",
      icon: <DeviceThermostat sx={{ fontSize: 90 }} color="primary" />,
    },
    {
      id: 4,
      pluginName: PLUGIN_NAME.MICRO_CONTROLLERS,
      show: mcsInfo?.hasDHT,
      title: "DHT_AVG_REPORT",
      subTitle: "HOURLY_AVERAGE",
      navigate: "Mc-Avg-DHT",
      icon: <WaterDropOutlined sx={{ fontSize: 90 }} color="primary" />,
    },
    {
      id: 4,
      pluginName: PLUGIN_NAME.MICRO_CONTROLLERS,
      show: temperatureReportControllers(mcList, user).length > 0,
      title: "TEMP_REPORT",
      navigate: "Mc-Temp",
      icon: <ThermostatAutoOutlined sx={{ fontSize: 90 }} color="primary" />,
    },
    {
      id: 5,
      pluginName: PLUGIN_NAME.SERVICES_CALL,
      show: true,
      title: "YEARLY_SERVICE_CALL_REPORT",
      navigate: "Yearly-Service-Call",
      icon: <CalendarMonth sx={{ fontSize: 90 }} color="primary" />,
    },
    {
      id: 6,
      pluginName: PLUGIN_NAME.MICRO_CONTROLLERS,
      show: mcsInfo?.hasRelayReports,
      title: "RELAY_POWER_REPORT",
      navigate: "Mc-Relay-Power",
      icon: <SettingsPower sx={{ fontSize: 90 }} color="primary" />,
    },
  ];

  const onClick = (nav) => {
    navigate(`${nav}`);
  };

  return (
    <CustomPage>
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "center", md: "start" }}
        spacing={2}
        useFlexGap
        sx={{ flexWrap: 'wrap' }}
      >
        {REPORTS_BUTTONS?.map((btn, idx) => {
          return (
            <NullCheck key={idx} valueForCheck={btn?.show && hasPlugin(btn.pluginName)}>
              <Stack
                sx={{ cursor: "pointer" }}
                onClick={() => onClick(btn?.navigate)}
                width={200}
                height={150}
                padding={1}
                border={2}
                alignItems="center"
                borderColor="primary.text"
                borderRadius={7}
              >
                {btn?.icon}
                <Typography textAlign="center" variant="h6">
                  {bt(btn?.title)}
                </Typography>

                <NullCheck valueForCheck={btn?.subTitle}>
                  <Typography textAlign="center" variant="body2" color="primary.text">
                    {bt(btn?.subTitle)}
                  </Typography>
                </NullCheck>
              </Stack>
            </NullCheck>
          );
        })}
      </Stack>
    </CustomPage>
  );
};
export default Reports;
